import script from "./MermaidLiveEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MermaidLiveEditorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./MermaidLiveEditorDialog.vue?vue&type=style&index=0&id=51f7d8cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f7d8cc"]])

export default __exports__